export default {"src":"/_next/static/media/water.14a477e8.svg","height":28,"width":20,"blurWidth":0,"blurHeight":0};